module.exports = __webpack_public_path__ + "static/img/image03.1cbe0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/landingPage/image03.png
// module id = +oov
// module chunks = 0